import React, { ReactNode } from 'react';
import className from 'classnames';
import { useIntl } from 'react-intl';

import sageIcon from './sage-icon.svg';
import styles from './desktop-nav-scaffold.scss';

interface OwnProps {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  main?: ReactNode;
  customClassName?: string;
}

type Props = OwnProps;

export const DesktopNavBarScaffold: React.FC<Props> = ({
  left,
  center,
  right,
  main,
  customClassName = ''
}): JSX.Element => {
  const intl = useIntl();

  return (
    <div className={className('is-hidden-touch', styles.flexSingle, styles.navContainer, customClassName)}>
      <section className={styles.leftSection} style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
        <img
          className={styles.sageLogo}
          src={sageIcon}
          alt={intl.formatMessage({ id: 'common.sage_logo', defaultMessage: 'Sage logo' })}
        />
        <div className={styles.productName}>
          {intl.formatMessage({ id: 'common.futrli', defaultMessage: 'Futrli' })}
        </div>
      </section>

      {main}

      {left && (
        <section className={styles.leftSection} style={{ justifyContent: 'flex-start' }}>
          {left}
        </section>
      )}

      {center && (
        <section className={styles.centerSection} style={{ marginLeft: 0, justifyContent: 'flex-start' }}>
          {center}
        </section>
      )}
      {right && <section className={styles.rightSection}>{right}</section>}
    </div>
  );
};
